type CapacityFullPageProps = {
  onRetry: () => void;
};

export function CapacityFullPage({ onRetry }: CapacityFullPageProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-12 px-6">
      <div className="w-full max-w-[480px]">
        <div className="bg-surface rounded-2xl border border-rule shadow-[0_4px_24px_rgba(0,0,0,0.08),0_1px_3px_rgba(0,0,0,0.04)] p-6">
          <h1 className="font-display text-[24px] font-bold text-ink tracking-[-0.02em] mb-2">
            Waiting for an available slot
          </h1>
          <p className="text-[15px] text-ink-muted mb-6">
            Traffic is currently full. Please retry in a moment.
          </p>

          <button
            data-testid="capacity-full-retry-button"
            onClick={onRetry}
            className="w-full py-3.5 bg-primary hover:bg-primary-deep text-white text-[15px] font-semibold rounded-xl transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
}
